var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalSuccessImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 59,
    r: 59,
    fill: "#34C353"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4536 79.1118C48.4823 79.1118 47.5104 78.7488 46.7695 78.0227L30.91 62.496C29.4268 61.0446 29.4268 58.6912 30.9094 57.2397C32.3926 55.7883 34.797 55.7883 36.2783 57.2397L49.4536 70.138L81.0245 39.2302C82.5064 37.7787 84.9121 37.7787 86.3928 39.2302C87.876 40.6816 87.876 43.035 86.3928 44.4865L52.1384 78.0227C51.3975 78.7488 50.4255 79.1118 49.4536 79.1118Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalSuccessImg);
export default __webpack_public_path__ + "static/media/modal-success-img.c0bf1b74b91f831797f281cf52f36411.svg";
export { ForwardRef as ReactComponent };